import React from 'react';
import styled, { css } from 'styled-components';

export const CheckboxWrapper = styled.div`
  display: flex;
  gap: 8px;
  .error {
    border-color: red;
  }
`;
export const CheckboxLabel = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  color: ${props => props.theme.colors.neutral[100]};
`;
const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 5px;
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div<{ selected: boolean }>`
  position: relative;
  width: 24px;
  height: 24px;
  border: 1px solid #d0d3d9;
  border-radius: 4px;
  box-sizing: border-box;
  background-color: rgba(0, 27, 83, 0.05);
  transition: all 150ms;
  ${({ selected }) =>
    selected &&
    css`
      border-color: #1c6acf;
      background-color: ${({ theme }) => theme.colors.primary[100]};
    `}
`;

const HiddenInput = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: 0;
  cursor: pointer;
  opacity: 0;
`;

export interface CustomCheckBoxProps {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  name: string;
  id?: string;
  label: string;
  placeholder?: string;
  value: string;
  selected: boolean;
}

export const CheckboxInput = (props: CustomCheckBoxProps) => {
  return (
    <CheckboxWrapper>
      <IconWrapper selected={props.selected}>
        {props.selected && (
          <Icon viewBox='0 0 24 24'>
            <polyline points='20 6 9 17 4 12' />
          </Icon>
        )}
        <HiddenInput type='checkbox' {...props} />
      </IconWrapper>
      <CheckboxLabel htmlFor={props.id || props.name}>
        {props.label}
      </CheckboxLabel>
    </CheckboxWrapper>
  );
};
